module.exports = __webpack_public_path__ + "school/img/ebooksWhzxBg.fbdcdc8f.jpg";